
import React from "react";
import { Badge } from "@/components/ui/badge";

interface TraitDescriptorsBadgesProps {
  traitDescriptors: string[];
  isVisible: boolean;
}

const TraitDescriptorsBadges: React.FC<TraitDescriptorsBadgesProps> = ({
  traitDescriptors,
  isVisible,
}) => (
  <div className="mb-16">
    <div className="flex flex-wrap gap-3">
      {traitDescriptors.map((trait, idx) => (
        <span
          key={idx}
          className="bg-muted text-foreground text-base py-2 px-4 border border-border"
        >
          {trait}
        </span>
      ))}
    </div>
  </div>
);

export default TraitDescriptorsBadges;
